import typeToReducer from 'type-to-reducer';
import { combineReducers } from 'redux';
import { loadingStateReducer } from '../utils';

import { LOAD_MACHINE_METRICS_ALERT_HISTORY } from './constants';

export default combineReducers({
  loadingState: loadingStateReducer([LOAD_MACHINE_METRICS_ALERT_HISTORY]),
  data: typeToReducer(
    {
      [LOAD_MACHINE_METRICS_ALERT_HISTORY]: {
        SUCCESS: (state, { payload }) => payload
      }
    },
    []
  )
});
